import React from 'react';
import { PropsWithChildren, useCallback, useLayoutEffect, useRef } from "react"
import ReactDOM from 'react-dom';

type MyProps = {
    isOpen: boolean,
    setOpen: Function
    width?: string,
    height?: string,
    clickOutSideClose?: boolean
}

const ModalContainer = ({ isOpen, setOpen, width, height, children, clickOutSideClose = true }: PropsWithChildren<MyProps>) => {
    const modalRoot = document.querySelector("#modal-root")
    const modalRef = useRef<HTMLDivElement>(null)

    const handleClickOutside: React.MouseEventHandler<HTMLButtonElement|HTMLDivElement> = useCallback((event) => {
        if (
            modalRef.current &&
            !modalRef.current.contains(event.target as HTMLDivElement)
            // if bootbox is needed above modal enable this condition
            //  && !document.querySelector(".bootbox")?.contains(event.target as HTMLDivElement)
        ) {
            setOpen(event);
        }
    }, [modalRef]);

    useLayoutEffect(() => {
        isOpen && clickOutSideClose ?
        document.addEventListener("mousedown", handleClickOutside as any) :
        document.removeEventListener("mousedown", handleClickOutside as any)
        return () => {
            document.removeEventListener("mousedown", handleClickOutside as any);
        };
    }, [handleClickOutside, isOpen])


    if(!isOpen || !modalRoot) return <></>

    return (
        <>
            {
                ReactDOM.createPortal(
                    <div id="delete-project-modal" className={`tw-fixed tw-w-screen tw-h-screen tw-top-0 tw-left-0 tw-z-[1040]`}>
                        <div 
                        className={`tw-absolute tw-top-0 tw-left-0 tw-bg-black tw-opacity-30 tw-w-full tw-h-full`}
                            
                        ></div>
                        <div ref = {modalRef} className={`tw-absolute tw-m-auto tw-min-w-[500px]
                            tw-min-h-[200px] tw-max-h-screen tw-max-w-screen tw-flex
                            tw-overflow-auto tw-bg-white tw-rounded tw-z-10 tw-flex-col
                            tw-top-1/2 tw--translate-y-1/2 tw-left-1/2 tw--translate-x-1/2 tw-shadow-sm`}
                            style = {{width: width ?? "auto", height: height ?? "auto"}}
                        >
                            {children}
                        </div>
                    </div>,
                    modalRoot
                )
            }
        </>
    )
}

export default ModalContainer